package dev.danko.roblox_craft_ai

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.loadFromLocalStorage
import com.varabyte.kobweb.silk.theme.colors.saveToLocalStorage
import com.varabyte.kobweb.silk.theme.colors.systemPreference
import dev.danko.roblox_craft_ai.uikit.theme.ProvideAppTheme
import dev.danko.roblox_craft_ai.uikit.theme.UI_FONT_STACK
import dev.danko.roblox_craft_ai.uikit.theme.CODE_FONT_STACK
import org.jetbrains.compose.web.css.px
import dev.danko.roblox_craft_ai.uikit.config.BackendCredentials
import dev.danko.roblox_craft_ai.uikit.util.PageScrollLock
import dev.danko.roblox_craft_ai.components.AccessGate
import dev.danko.roblox_craft_ai.components.AuthHost
import org.jetbrains.compose.web.css.vh

private const val COLOR_MODE_KEY = "roblox_craft_ai:colorMode"

@InitSilk
fun initColorMode(ctx: InitSilkContext) {
    ctx.config.initialColorMode = ColorMode.loadFromLocalStorage(COLOR_MODE_KEY) ?: ColorMode.systemPreference
}

@InitSilk
fun initPageScroll(ctx: InitSilkContext) {
    PageScrollLock.reset()
}

@InitSilk
fun initStyles(ctx: InitSilkContext) {
    ctx.stylesheet.apply {
        // The page itself scrolls (not a 100%-high body with its own overflow): on macOS, Chrome latches trackpad
        // gestures to the root scroller, so a scrolling body only reacted to a mouse wheel. overflow-x on body
        // propagates to the viewport, and the scroll lock of dialogs (body overflow: hidden) keeps working.
        registerStyleBase("html, body") {
            Modifier.fillMaxWidth()
        }
        registerStyleBase("body") {
            Modifier.overflow { x(com.varabyte.kobweb.compose.css.Overflow.Hidden) }
        }
        registerStyleBase("body") {
            Modifier
                .fontFamily(*UI_FONT_STACK.split(",").map { it.trim().trim('\'') }.toTypedArray())
                .fontSize(15.px)
                .lineHeight(1.5)
                .styleModifier { property("-webkit-font-smoothing", "antialiased") }
        }
        registerStyleBase("code, pre, kbd, samp") {
            Modifier.fontFamily(*CODE_FONT_STACK.split(",").map { it.trim().trim('\'') }.toTypedArray())
        }
    }
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    BackendCredentials.install()
    SilkApp {
        val colorMode = ColorMode.current
        LaunchedEffect(colorMode) {
            colorMode.saveToLocalStorage(COLOR_MODE_KEY)
        }
        Surface(SmoothColorStyle.toModifier().minHeight(100.vh)) {
            ProvideAppTheme {
                AccessGate { content() }
                AuthHost()
            }
        }
    }
}
